import { FFInPageEditInput, getInPageEditFullWidth, getInPageEditType } from "components/Freefields/InPageEdit/FFInPageEditInput";
import { FreefieldCategoryWithValuesAndPermissions } from "components/Freefields/models";
import ReadonlyFreefieldValue from "components/Freefields/Readonly/ReadonlyFreefieldValue";
import { FormSection } from "components/MainSectionTemplate/types";
import { AxiosResponse } from "axios";
import React from "react";
import { isFreeFieldDateEmpty } from "shared/utils/freeFieldUtils";


const freefieldKeyPrefix = "freefieldId-";
export const isFreefieldKey = (key: string): boolean => {
  return key.startsWith(freefieldKeyPrefix);
}

export const getFreefieldId = (key: string): number => {
  if (!isFreefieldKey(key)) {
    throw new Error(`Key ${key} is not a freefield key`);
  }
  return parseInt(key.substring(freefieldKeyPrefix.length));
}

const isEmpty = (displayValue: string, type: server.dto.FormElementTypes): boolean => {
  if (type === "date" || type === "dateTime" || type === "time") {
    return isFreeFieldDateEmpty(displayValue);
  }

  return !displayValue;
}

const clearableTypes: server.dto.FormElementTypes[] = ["dropdown"];

export const freeFieldEditableSections = (
  itemId: number, // The production or show id
  ffCategoriesAndValues: FreefieldCategoryWithValuesAndPermissions[],
  submitFunc: (dto: server.dto.UpdateFreeFieldValueInstruction) => Promise<AxiosResponse<server.dto.ApiResponse, any>>,
): Array<FormSection> => {
  return ffCategoriesAndValues
    .map(category => ({
      key: `${category.freeFieldCategoryId}`,
      type: "collapsable",
      title: category.title,
      hidden: category.definitionWithValues.every(def => def.permission === "hidden"),
      fields: category.definitionWithValues
        .map(def => ({
          key: `${freefieldKeyPrefix}${def.freeFieldDefinitionId}`,
          label: def.title,
          sublabel: def.description,
          editDisabled: def.permission !== "viewModify",
          hidden: def.permission === "hidden",
          isEmpty: isEmpty(def.displayValue.value, def.type),
          render: () => <ReadonlyFreefieldValue
            type={def.type}
            displayValue={def.displayValue}
          />,
          inPageEdit: {
            canRemove: clearableTypes.includes(def.type) && def.permission === "viewModify",
            type: getInPageEditType(def.type),
            fullWidth: getInPageEditFullWidth(def.type),
            initialValue: def.displayValue.value,
            render: ({ cancel, submit, value, onChange }) => <FFInPageEditInput
              type={def.type}
              value={value}
              onChange={onChange}
              cancel={cancel}
              submit={submit}
              dropdownOptions={def.dropdownOptions}
              reference={def.reference}
            />,
            submitChange: (value: string) => submitFunc({
              definitionId: def.freeFieldDefinitionId,
              value: value,
              itemId,
            })
          },
        })),
    }))
}